import Checkbox from '@/components/molecules/Checkbox';
import * as S from './styles';
import Text from '@/components/atoms/Text';
import TextoTermosChippu from '@/components/molecules/TextoTermosChippu';

interface CheckboxConcordarTermosProdutosProps {
  usuarioAceitouOsTermos: boolean;
  setUsuarioAceitouTermosProdutos: (
    valor: boolean | ((prev: boolean) => boolean),
  ) => void;
  mostrarTermosChippu?: boolean;
  mostrarTermosAssinatura?: boolean;
}

export default function CheckboxConcordarTermosProdutos(
  props: CheckboxConcordarTermosProdutosProps,
) {
  const {
    usuarioAceitouOsTermos,
    setUsuarioAceitouTermosProdutos,
    mostrarTermosAssinatura = false,
    mostrarTermosChippu = false,
  } = props;
  return (
    <S.Container>
      <S.ButtonAlterarEstadoCheckbox
        onClick={() =>
          setUsuarioAceitouTermosProdutos(
            (itemAnterior: boolean) => !itemAnterior,
          )
        }
      >
        <Checkbox
          $size={1}
          $highContrast={false}
          $status={usuarioAceitouOsTermos ? 'checked' : 'unchecked'}
          $variant="classic"
        />
        <Text
          $size={2}
          $color="neutral"
          $weight="medium"
          $align="left"
          $highContrast={true}
          $text={
            <>
              {`Eu li e concordo com os ${mostrarTermosAssinatura ? 'Termos e Condições das assinaturas' : ''}`}
              {mostrarTermosChippu ? (
                <>
                  {' '}
                  <TextoTermosChippu
                    highConstrast
                    primeiroTexto={
                      mostrarTermosAssinatura && mostrarTermosChippu
                        ? 'e com os '
                        : ''
                    }
                    ultimoTexto=" do Chippu."
                    mostrarPoliticaPrivacidade={false}
                  />
                </>
              ) : null}
            </>
          }
        />
      </S.ButtonAlterarEstadoCheckbox>
    </S.Container>
  );
}
